import http from "../http";
import { API_BASE_URL, RIDE_OVERRIDE_KEY } from "../../config";

const overrideHeaders = () =>
  RIDE_OVERRIDE_KEY ? { "x-override-key": RIDE_OVERRIDE_KEY } : {};

export default class RideShareAdminService {
  static getBidDetails(params = {}) {
    return http
      .get(`${API_BASE_URL}/v2/admin/bids`, { params })
      .then((res) => res);
  }

  static getBidDrivers(params = {}) {
    return http
      .get(`${API_BASE_URL}/v2/admin/bids/drivers`, { params })
      .then((res) => res);
  }

  static getCompletedRides(params = {}) {
    return http
      .get(`${API_BASE_URL}/v2/admin/rides/completed`, {
        params,
        headers: overrideHeaders(),
      })
      .then((res) => res);
  }

  static getCompletedRideDetails(rideId) {
    return http
      .get(`${API_BASE_URL}/v2/admin/rides/completed/${rideId}`, {
        headers: overrideHeaders(),
      })
      .then((res) => res);
  }

  static forceCompleteRide(rideId) {
    return http
      .post(
        `${API_BASE_URL}/v2/admin/rides/${rideId}/force-complete`,
        {},
        { headers: overrideHeaders() },
      )
      .then((res) => res);
  }

  static undoForceCompleteRide(rideId) {
    return http
      .post(
        `${API_BASE_URL}/v2/admin/rides/${rideId}/force-complete/undo`,
        {},
        { headers: overrideHeaders() },
      )
      .then((res) => res);
  }

  static getDriverOcr(driverId) {
    return http
      .get(`${API_BASE_URL}/v2/admin/drivers/${driverId}/ocr`)
      .then((res) => res);
  }

  static updateDriverOcr(driverId, documentType, payload = {}) {
    return http
      .put(
        `${API_BASE_URL}/v2/admin/drivers/${driverId}/ocr/${documentType}`,
        payload,
      )
      .then((res) => res);
  }

  static reviewDriverOcr(driverId, documentType, payload = {}) {
    return http
      .put(
        `${API_BASE_URL}/v2/admin/drivers/${driverId}/ocr/${documentType}/review`,
        payload,
      )
      .then((res) => res);
  }
}
